import React, { FC } from 'react';

import { fullHeight, fullWidth, scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import ImageHandlingPopup from '@v2/components/imageHandling/components/Header/components/ImageHandlingPopup';
import { InfoPopupWebProps } from './InfoPopupWeb';
import { useManageInfoPopupTabletMobile } from './hooks/useManageInfoPopupTabletMobile';
import ModalWrapper from '@components/modal/ModalWrapper';
import InfoModal from './InfoModal';
import { View } from 'react-native';
import { modalBg } from '@v2/pages/common/constants/base.constants';

interface InfoPopupTabletMobileProps extends InfoPopupWebProps {}

const InfoPopupTabletMobile: FC<InfoPopupTabletMobileProps> = (props) => {
  const {
    images,
    selectedIndex,
    deleteImage,
    C,
    setSelectedIndex,
    visible,
    onClose,
    list: listFromProps,
    scale = initialScale,
    font = initialFont,
    iconPosition,
  } = props;
  const { list, closeInfoModal, isInfoModalVisible } = useManageInfoPopupTabletMobile({
    deleteImage,
    images,
    selectedIndex,
    setSelectedIndex,
    font,
    list: listFromProps,
    C,
    scale,
  });

  if (isInfoModalVisible) {
    return (
      <ModalWrapper backdropColor={'Overlay/Light/Dim strong'} isVisible={isInfoModalVisible} onBackdropPress={closeInfoModal} C={C}>
        <View
          style={[
            {
              position: 'relative',
              alignSelf: 'center',
              width: Math.min(fullWidth, scale(480)),
              maxHeight: scale(fullHeight - 40),
              backgroundColor: C(modalBg),
              borderRadius: scale(9),
            },
          ]}
        >
          <InfoModal {...{ modalInfoVisible: true, triggerInfoModal: closeInfoModal, C, images, selectedIndex, scale, font }} />
        </View>
      </ModalWrapper>
    );
  }

  if (!visible) return null;

  return (
    <>
      <ImageHandlingPopup {...{ C, list, loading: false, onClose, scale, font, iconPosition }} />
    </>
  );
};

export default InfoPopupTabletMobile;
